import {ArrowRightOutlined, EditOutlined, UserOutlined} from "@ant-design/icons";
import {useGetProfileContext} from "../../../context/profile/profile-context";
import {
  StyledSidebarProfileAvatarEditIconWrapper,
  StyledSidebarProfileAvatarWrapper,
  StyledSidebarProfileInfoWrapper,
  StyledSidebarProfileShareWrapper,
  StyledSidebarProfileWrapper,
} from "./sidebar-profile.style";
import {Avatar, message, Space} from "antd";
import {Link} from "react-router-dom";
import {
  CopyIconSm,
  FacebookIconSm,
  MailIcon,
  TwitterIconSm,
  XIcon,
} from "../../icons/icons";
import {REBRAND_BASE_URL} from "../../../services/config";
import {handleDisplayName} from "../../../utils/profile";

export function SidebarProfile() {
  const {state} = useGetProfileContext();

  function handleViewProfile() {
    setTimeout(() => {
      window.open(`/${state.profileData.username}`);
    }, 0);
  }
  return (
    <StyledSidebarProfileWrapper>
      <div>
        <Space size={20}>
          <StyledSidebarProfileAvatarWrapper>
            {state.profileData.avatar ? (
              <Avatar size={50} src={state.profileData.avatar} />
            ) : (
              <Avatar size={50} icon={<UserOutlined />} />
            )}
            <StyledSidebarProfileAvatarEditIconWrapper>
              <Link to="/profile">
                <div
                  style={{
                    width: "3rem",
                    height: "2.5rem",
                    backgroundColor: "#222222",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "5px",
                    border: "2px solid #F0F0F0",
                  }}
                >
                  <EditOutlined style={{fontSize: "1.6rem"}} />
                </div>
                {/* <Button
                  icon={<EditOutlined />}
                  shape="circle"
                  type="primary"
                  size="small"
                  style={{
                    minWidth: "2rem",
                    width: "2rem",
                    height: "2rem",
                  }}
                /> */}
              </Link>
            </StyledSidebarProfileAvatarEditIconWrapper>
          </StyledSidebarProfileAvatarWrapper>
          <StyledSidebarProfileInfoWrapper>
            <p className="profile-name">
              {handleDisplayName({
                firstName: state.profileData.firstName,
                lastName: state.profileData.lastName,
                displayName: state.profileData?.display_name!,
              })}
            </p>
            <a
              href={`${REBRAND_BASE_URL}/${state.profileData.username}`}
              target="_blank"
              rel="noreferrer"
              style={{textDecoration: "underline"}}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontWeight: 600,
                  fontSize: "1.4rem",
                }}
              >
                Public Profile <ArrowRightOutlined />
              </span>
            </a>
          </StyledSidebarProfileInfoWrapper>
        </Space>
      </div>
      <StyledSidebarProfileShareWrapper>
        {/* <ShareOfferingWidget title="Share profile via" extraParams={extraParams} /> */}
        <p className="share-text">Share profile via</p>
        <div>
          <Space direction="horizontal" size={12}>
            <div
              style={{
                color: "#9254DE",
                height: "3rem",
                width: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a
                href="#!"
                title="Copy link"
                onClick={() =>
                  navigator.clipboard
                    .writeText(`${REBRAND_BASE_URL}/${state.profileData.username}`)
                    .then(() => message.success("Link copied"))
                }
              >
                <CopyIconSm style={{fontSize: "2rem"}} />
              </a>
            </div>
            <div
              style={{
                color: "#3B5998",
                height: "3rem",
                width: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcoachli.co%2F${state.profileData.username}&amp`}
                title="Share on Facebook"
              >
                <FacebookIconSm style={{fontSize: "2rem"}} />
              </a>
            </div>
            <div
              style={{
                border: "none",
                height: "3rem",
                width: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://twitter.com/intent/tweet?text=Book a session with me on Coachli!&url=${REBRAND_BASE_URL}/${state.profileData.username}&hashtags=coachli,useCoachli`}
                title="Share on X"
              >
                <XIcon style={{fontSize: "2rem"}} />
              </a>
            </div>
            <div
              style={{
                border: "none",
                height: "3rem",
                width: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a
                title="Share through e-mail"
                href={`mailto:?subject=I wanted you to see this site&amp;body=Book a session with me on Coachli ${REBRAND_BASE_URL}/${state.profileData.username}`}
              >
                <MailIcon style={{fontSize: "2rem"}} />
              </a>
            </div>
          </Space>
        </div>
      </StyledSidebarProfileShareWrapper>
    </StyledSidebarProfileWrapper>
  );
}
